import { DatePickerInput } from '@delmonicos/shared-design-system-react/src/components/date-picker-input/date-picker-input';
import {
  DatePickerSingleProps,
  ModeEnum,
} from '@delmonicos/shared-design-system-react/src/components/date-picker/date-picker';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useTranslation } from 'react-i18next';

interface EmspBoTariffUpdatedAfterFilterControllerProps
  extends Pick<DatePickerSingleProps, 'onSelect' | 'selected'> {}

export const EmspBoTariffUpdatedAfterFilterController = ({
  selected,
  onSelect,
}: EmspBoTariffUpdatedAfterFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="calendar-date"
        text={t(
          'delmonicos-shared-sdk.inputs-filterable-fields-pagination.updated-after',
        )}
      />
      <Stack gap={GapEnum.S} direction="column">
        <DatePickerInput
          mode={ModeEnum.Single}
          selected={selected}
          onSelect={onSelect}
        />
      </Stack>
    </Stack>
  );
};
